import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": "landing-hero sh-gradient-light"
};
var _hoisted_2 = {
  "class": "container"
};
var _hoisted_3 = {
  "class": "pt-5 pb-4 mt-lg-5 mb-lg-4 mb-3"
};
var _hoisted_4 = {
  "class": ""
};
var _hoisted_5 = {
  "class": "mt-4 pb-3 mb-5"
};
var _hoisted_6 = {
  "class": "row gx-3 align-items-end justify-content-center"
};
var _hoisted_7 = {
  "class": "col-xxl-8 col-xl-9 col-md-10"
};
var _hoisted_8 = {
  id: "search-product",
  "class": "position-relative"
};
var _hoisted_9 = {
  "class": "col-md-2"
};
var _hoisted_10 = {
  "class": "d-grid mt-md-0 mt-3"
};
var _hoisted_11 = {
  key: 0,
  "class": "row justify-content-center mt-n4"
};
var _hoisted_12 = {
  "class": "col-xxl-10 col-xl-11 col-md-12"
};
var _hoisted_13 = {
  "class": "filter-search pb-1"
};
var _hoisted_14 = {
  "class": "pt-3 d-grid d-md-block"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[12] || (_cache[12] = _createElementVNode("div", {
    "class": "text-center"
  }, [_createElementVNode("h1", {
    "class": "sh-text-dark-blue"
  }, "Wholesale items to sell"), _createElementVNode("div", {
    "class": "subheader font-size-md-16 mt-2 mb-4"
  }, "Find wholesale items you can sell online to make a profit")], -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[10] || (_cache[10] = _createElementVNode("label", {
    "class": "font-size-12 opacity-60 mb-1"
  }, "I want to sell...", -1)), _createElementVNode("div", _hoisted_8, [_createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = _withModifiers(function () {
      return $options.randomQuerySearch && $options.randomQuerySearch.apply($options, arguments);
    }, ["prevent"])),
    href: "#",
    "class": "position-absolute top-50 end-0 translate-middle-y text-decoration-none btn-idea d-flex align-items-center me-3 font-weight-semibold"
  }, _cache[9] || (_cache[9] = [_createElementVNode("img", {
    src: "/img/v5/ws-ico-idea.svg",
    "class": "me-2"
  }, null, -1), _createTextVNode(" Give me an idea")])), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $options.query = $event;
    }),
    type: "search",
    "class": "form-control fc-y-padding form-control-search typeahead",
    placeholder: "I want to sell..."
  }, null, 512), [[_vModelText, $options.query]])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = _withModifiers(function () {
      return $options.performSearch && $options.performSearch.apply($options, arguments);
    }, ["prevent"])),
    type: "submit",
    "class": "btn btn-primary"
  }, "Search")])])])]), $options.query ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[11] || (_cache[11] = _createElementVNode("div", {
    "class": "font-size-14"
  }, "Quickly refine your results using our filters", -1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("button", {
    onClick: _cache[3] || (_cache[3] = _withModifiers(function ($event) {
      return $options.toggleFilterAndSearch('ships_internationally', 1, 0);
    }, ["prevent"])),
    type: "button",
    "class": "btn btn-white rounded-pill font-size-13 pe-3 me-2 mb-md-3 mb-2",
    "data-bs-toggle": "button"
  }, "🌎 Worldwide Shipping"), _ctx.userCountryCode ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    onClick: _cache[4] || (_cache[4] = _withModifiers(function ($event) {
      return $options.toggleFilterAndSearch('countries', _ctx.userCountryCode, '');
    }, ["prevent"])),
    type: "button",
    "class": "btn btn-white rounded-pill font-size-13 pe-3 me-2 mb-md-3 mb-2",
    "data-bs-toggle": "button"
  }, "📍 Ships to " + _toDisplayString(_ctx.userCountryCode), 1)) : _createCommentVNode("", true), _createElementVNode("button", {
    onClick: _cache[5] || (_cache[5] = _withModifiers(function ($event) {
      return $options.toggleFilterAndSearch('minimum_order_value', 0, -1);
    }, ["prevent"])),
    type: "button",
    "class": "btn btn-white rounded-pill font-size-13 pe-3 me-2 mb-md-3 mb-2",
    "data-bs-toggle": "button"
  }, "🛒️ No minimum order"), _createElementVNode("button", {
    onClick: _cache[6] || (_cache[6] = _withModifiers(function ($event) {
      return $options.toggleFilterAndSearch('types', 'Wholesalers', '');
    }, ["prevent"])),
    type: "button",
    "class": "btn btn-white rounded-pill font-size-13 pe-3 me-2 mb-md-3 mb-2",
    "data-bs-toggle": "button"
  }, "📦 Wholesalers"), _createElementVNode("button", {
    onClick: _cache[7] || (_cache[7] = _withModifiers(function ($event) {
      return $options.toggleFilterAndSearch('types', 'Dropshippers', '');
    }, ["prevent"])),
    type: "button",
    "class": "btn btn-white rounded-pill font-size-13 pe-3 me-2 mb-md-3 mb-2",
    "data-bs-toggle": "button"
  }, "🚚 Dropshippers"), _createElementVNode("button", {
    onClick: _cache[8] || (_cache[8] = _withModifiers(function ($event) {
      return $options.toggleFilterAndSearch('types', 'Manufacturers', '');
    }, ["prevent"])),
    type: "button",
    "class": "btn btn-white rounded-pill font-size-13 pe-3 me-2 mb-md-3 mb-2",
    "data-bs-toggle": "button"
  }, "🏭 Manufacturers")])])])])) : _createCommentVNode("", true)])])])]);
}